import { Box, makeStyles } from '@material-ui/core'
import { FileCopy } from '@material-ui/icons'
import ThemeButton from 'Components/ThemeButton'
import React from 'react'
import { Button, IconButton } from 'procyon-ui'
import { enqueueNotification } from 'Utils/Helpers'
import { faCopy } from '@fortawesome/free-solid-svg-icons'
const useStyle = makeStyles((theme) => ({
  root: {},
  text: {
    borderRadius: theme.spacing(0.25),
    padding: theme.spacing(1),
    height: theme.spacing(14),
    overflowY: 'auto',
    overflowX: 'hidden',
    background: theme.palette.info.main,
    color: 'white',
    wordBreak: 'break-word'
  }
}))
const CommandViewer = ({ command, actionLabel, copyMessage }) => {
  const classes = useStyle()
  const copyCommand = () => {
    try {
      navigator.clipboard.writeText(command)
      enqueueNotification(copyMessage, 'info')
    } catch (error) {
      console.error('error in handleCopy: ', error)
    }
  }
  return (
    <div className='flex flex-col overflow-hidden'>
      <div className='bg-gray-900 text-blue-400 break-words max-h-[180px] overflow-scroll font-mono p-4 rounded-lg text-[15px] w-full'>
        {command}{' '}
      </div>
      <div className='flex justify-right mt-4'>
        <Button variant='grayBlue' disabled={!command} onClick={copyCommand}>
          {actionLabel}
          <IconButton style={{ width: 20 }} icon={faCopy} variant='grayBlue' />
        </Button>
      </div>
    </div>
  )
}

export default CommandViewer
